function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  rx: 9,
  transform: "translate(7 7)",
  fill: "#FDC055"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  rx: 9,
  transform: "translate(7 7)",
  fill: "#32CEFF"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  rx: 9,
  transform: "translate(7 7)",
  fill: "#8E6AF6"
});

var SvgIconCirActive = function SvgIconCirActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjE4IiBoZWlnaHQ9IjE4IiByeD0iOSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNyA3KSIgZmlsbD0iI0ZEQzA1NSIvPgo8cmVjdCB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHJ4PSI5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3IDcpIiBmaWxsPSIjMzJDRUZGIi8+CjxyZWN0IHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgcng9IjkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcgNykiIGZpbGw9IiM4RTZBRjYiLz4KPC9zdmc+Cg==";
export { SvgIconCirActive as ReactComponent };